<template>
  <!-- 6-1 医疗机构员工管理 -->
  <div class="main-css">
    <!--    标题-->
    <div class="title-css">{{ $t("staffManagement") }}</div>
    <div class="main-box">
      <!-- button 部分 -->
      <div class="line-button-box">
        <el-button class="button-css" @click="handleAddClick"
          >＋{{ $t("NewStaff") }}</el-button
        >
      </div>
      <!-- table部分 -->
      <div class="table">
        <el-table
          :data="tableData"
          :height="tableHeight"
          @sort-change="changeTableSort"
          v-loading="loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" min-width="55"> </el-table-column>
          <!-- ----------------------ユーザーID---------------------- -->
          <el-table-column
            prop="userId"
            label="ユーザーID"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p class="operate">{{ $t("userID") }}</p>
            </template>
            <template slot-scope="scope">
              {{ scope.row.userId }}
            </template>
          </el-table-column>
          <!-- ----------------------氏名---------------------- -->
          <el-table-column
            prop="userName"
            label="氏名"
            min-width="100"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("name") }}</p>
              <el-input
                v-model="searchData2"
                size="mini"
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
          </el-table-column>
          <!-- ---------------------权限-------------------- -->
          <el-table-column label="权限" min-width="150">
            <template slot="header">
              <p>{{ $t("limit") }}</p>
              <el-dropdown @command="handleCommandapplyAdmin">
                <span class="el-dropdown-link">
                  {{ applyAdminName
                  }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-for="(item, index) in applyAdminData"
                    :key="item.code"
                    :command="item"
                    >{{ item.name }}</el-dropdown-item
                  >
                  <el-dropdown-item :command="null">
                    ALL
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template slot-scope="scope">
              <span v-if="language === 'CN'">
                {{ scope.row.roleName_dictText }}
              </span>
              <span v-else>
                {{ scope.row.jproleName_dictText }}
              </span>
            </template>
          </el-table-column>

          <!-- ----------------------邮箱---------------------- -->
          <el-table-column
            prop="emailAddress"
            label="邮箱"
            min-width="120px"
            :show-overflow-tooltip="true"
          >
            <template slot="header" slot-scope="scope">
              <p>{{ $t("emil") }}</p>
              <el-input
                v-model="searchData3"
                size="mini"
                placeholder="Search"
                @change="FuzzyQuery"
              />
            </template>
          </el-table-column>
          <!-- -----------------------担当案件数----------------------- -->
          <el-table-column
            prop="leadNumber"
            label="担当案件数"
            min-width="120"
            sortable
          >
            <template slot="header">
              <p class="operate">{{ $t("numberOfCases") }}</p>
            </template>
            <!--            <template slot-scope="scope">-->
            <!--              {{ scope.row.casesNumber }}-->
            <!--            </template>-->
          </el-table-column>
          <!-- ------------------------给予管理员权限------------------------ -->
          <el-table-column
            prop="operation"
            label="给予管理员权限"
            sortable
            min-width="150"
          >
            <template slot="header">
              <p class="operate">{{ $t("GiveAdministrator") }}</p>
            </template>
            <template slot-scope="scope">
              <button
              v-if="scope.row.userStatus!=='2'"
                class="myButton-changlimit"
                @click="handleIsShow(scope.row)"
              >
                {{ $t("GiveAdministrator") }}
              </button>
            </template>
          </el-table-column>

          <!-- --------------------------操作-------------------------- -->
          <el-table-column label="操作" width="350" fixed="right">
            <template slot="header">
              <p class="operate">{{ $t("operate") }}</p>
            </template>

            <template slot-scope="scope">
              <!--              编辑按钮-->
              <button
                @click="staffApplicationHandleAdd(scope.row)"
                  v-if="scope.row.userStatus!=='2'"
                class="staff-application"
              >
                {{ $t("edit") }}
              </button>
              <!--              正式员工按钮-->
              <button
                v-if="scope.row.userStatus == 0"
                @click="staffApplicationHandleStop(scope.row)"
                class="staff-application"
              >
                {{ $t("stopUsing") }}
              </button>
              <!-- <button
                v-if="scope.row.userStatus == 0"
                @click="managerApplicationHandleDelete(scope.row)"
                class="manager-application"
              >
                {{ $t("delete") }}
              </button> -->
              <!--              申请员工按钮-->
              <button
                v-if="scope.row.userStatus == 2"
                @click="passtrue(scope.row)"
                class="manager-application"
              >
                OK
              </button>
              <button
                v-if="scope.row.userStatus == 2"
                @click="passfalse(scope.row)"
                class="manager-application"
              >
                NO
              </button>
              <!--              禁用状态下按钮-->
              <button
                v-if="scope.row.userStatus == 1"
                @click="staffApplicationHandleStop(scope.row)"
                class="staff-application"
              >
                {{ $t("startUsing") }}
              </button>
              <!-- <button
                v-if="scope.row.userStatus == 1"
                @click="managerApplicationHandleDelete(scope.row)"
                class="manager-application"
              >
                {{ $t("delete") }}
              </button> -->
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页部分 -->
        <div class="pagination">
          <div class="pagination-main">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              layout=" prev, pager, next"
              :total="total"
              :page-size="pageSize"
            >
            </el-pagination>
            <!-- Rows per page -->
            <div class="rowsPage">
              <span>Rows per page</span>
              <div class="rowsPage-css">
                <el-dropdown @command="handleCommand">
                  <span class="el-dropdown-link">
                    {{ pageSize
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="a">7</el-dropdown-item>
                    <el-dropdown-item command="b">15</el-dropdown-item>
                    <el-dropdown-item command="c">20</el-dropdown-item>
                    <el-dropdown-item command="d">25</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 弹窗编辑 -->
      <div class="employee-application" v-if="dialogIsShow">
        <div class="dialog-box">
          <div class="bottom-box-title">
            <p class="ja-welcome">
              <span>{{ $t("edit") }}</span>
            </p>
          </div>
          <!-- 关闭按钮 -->
          <div class="close-button" @click="dialogClose">×</div>

          <div class="box-form">
            <!--    name    -->
            <div class="emil-input-first">
              <p class="emil-input-title">
                {{ $t("name") }}
              </p>

              <div class="emil-input-css">
                <img
                  src="./assets/User_01.svg"
                  alt=""
                  class="emil-icon"
                  @error="
                    e => {
                      e.target.src = require('@/assets/defaultImg.png');
                    }
                  "
                />
                <form class="form-input-css-main">
                  <input
                    type="text"
                    class="emil-input-css-main"
                    v-model="list.userName"
                  />
                </form>
              </div>
            </div>
            <!--     email      -->
            <div class="emil-input">
              <p class="emil-input-title">
                {{ $t("emil") }}
              </p>
              <div class="emil-input-css">
                <img src="./assets/Vector (1).png" alt="" class="emil-icon" />
                <form class="form-input-css-main">
                  <input
                    type="text"
                    class="emil-input-css-main"
                    v-model="list.emailAddress"
                    @blur="emailVerification"
                    autocomplete="off"
                  />
                </form>
              </div>
            </div>

            <!--     パスワード      -->
            <div class="emil-input">
              <p class="emil-input-title">
                {{ $t("password") }}
              </p>
              <div class="emil-input-css">
                <img src="./assets/Vector.png" alt="" class="emil-icon" />
                <form class="form-input-css-main">
                  <input
                    type="password"
                    class="emil-input-css-main"
                    v-model="password"
                    autocomplete="off"
                  />
                </form>
              </div>
            </div>

            <!--     email      -->
            <div class="emil-input">
              <p class="emil-input-title">
                {{ $t("confirmPassword") }}
              </p>
              <div class="emil-input-css">
                <img src="./assets/Vector.png" alt="" class="emil-icon" />
                <form class="form-input-css-main">
                  <input
                    type="password"
                    class="emil-input-css-main"
                    v-model="repassword"
                    autocomplete="off"
                  />
                </form>
              </div>
            </div>
          </div>
          <!-- 确定按钮 -->
          <div class="insure">
            <button class="insure-button" @click="submit">
              {{ $t("confirm") }}
            </button>
          </div>
          <!--          头像部分-->
          <div class="Avatar">
            <div class="Avatar-img" @click="toGetImg" v-if="!imageUrl">
              <div class="add-icon" v-if="imgUrlAv === ''">
                <i class="el-icon-plus"></i>
              </div>
              <div class="add-icon" v-if="imgUrlAv !== ''">
                <img
                  class="add-icon-img"
                  :src="imgUrlAv"
                  @error="
                    e => {
                      e.target.src = require('@/assets/defaultImg.png');
                    }
                  "
                  alt=""
                />
              </div>
              <!-- https://test202257.oss-cn-shanghai.aliyuncs.com/image/68289087039b4e1391f439a8f93e3fd4.jpg -->
              <!-- https://test202257.oss-cn-shanghai.aliyuncs.com/ht%E2%80%A6cs.com/image/68289087039b4e1391f439a8f93e3fd4.jpg -->
            </div>
          </div>
        </div>
      </div>
      <!-- ok dialog -->
      <div class="employee-application" v-if="dialogIsShowOK">
        <div class="dialog-box-2">
          <div class="dialog-img-css">
            <div class="img-box">?</div>
          </div>
          <div class="dialog-title">
            {{ $t("sureAboutThisOperation") }}
          </div>
          <div class="dialog-button">
            <button @click="binDingOrganOKClick">{{ $t("confirm") }}</button>
          </div>
          <!-- 关闭按钮 -->
          <div class="close-button" @click="dialogOKClose">×</div>
        </div>
      </div>
      <!-- no dialog -->
      <div class="employee-application" v-if="dialogIsShowNO">
        <div class="dialog-box-2">
          <div class="dialog-img-css">
            <div class="img-box">?</div>
          </div>
          <div class="dialog-title">
            {{ $t("sureAboutThisOperation") }}
          </div>
          <div class="dialog-button">
            <button @click="binDingOrganNOClick">{{ $t("confirm") }}</button>
          </div>
          <!-- 关闭按钮 -->
          <div class="close-button" @click="dialogNOClose">×</div>
        </div>
      </div>
      <!-- 给予管理员dialog -->
      <div class="employee-application" v-if="dialoghandleIsShow">
        <div class="dialog-box-2">
          <div class="dialog-img-css">
            <div class="img-box">?</div>
          </div>
          <div class="dialog-title">
            {{ $t("sureAboutThisOperation") }}
          </div>
          <div class="dialog-button">
            <button @click="dialoghandleIsShowClick">
              {{ $t("confirm") }}
            </button>
          </div>
          <!-- 关闭按钮 -->
          <div class="close-button" @click="dialoghandleIsShowClose">×</div>
        </div>
      </div>
      <!-- 删除确认 dialog-->
      <div class="employee-application" v-if="dialoghandleIsdelete">
        <div class="dialog-box-2">
          <div class="dialog-img-css">
            <div class="img-box">?</div>
          </div>
          <div class="dialog-title">
            {{ $t("sureAboutThisOperation") }}
          </div>
          <div class="dialog-button">
            <button @click="dialoghandleIsdeleteClick">
              {{ $t("confirm") }}
            </button>
          </div>
          <!-- 关闭按钮 -->
          <div class="close-button" @click="dialoghandleIsdeleteClose">×</div>
        </div>
      </div>
      <!-- 弹窗新增 -->
      <div class="employee-application" v-if="dialogIsShow1">
        <div class="dialog-box">
          <div class="bottom-box-title">
            <p class="ja-welcome">
              <span>{{ $t("NewStaff") }}</span>
            </p>
          </div>
          <!-- 关闭按钮 -->
          <div class="close-button" @click="dialogClose1">×</div>

          <div class="box-form">
            <!--    name    -->
            <div class="emil-input-first">
              <p class="emil-input-title">
                {{ $t("name") }}
              </p>
              <div class="emil-input-css">
                <img src="./assets/User_01.svg" alt="" class="emil-icon" />
                <form class="form-input-css-main">
                  <input
                    type="text"
                    class="emil-input-css-main"
                    v-model="list.userName"
                  />
                </form>
              </div>
            </div>
            <!--     email      -->
            <div class="emil-input">
              <p class="emil-input-title">
                {{ $t("emil") }}
              </p>
              <div class="emil-input-css">
                <img src="./assets/Vector (1).png" alt="" class="emil-icon" />
                <form class="form-input-css-main">
                  <input
                    type="text"
                    class="emil-input-css-main"
                    v-model="list.emailAddress"
                    @blur="emailVerification"
                    autocomplete="off"
                  />
                </form>
              </div>
            </div>

            <!--     パスワード      -->
            <div class="emil-input">
              <p class="emil-input-title">
                {{ $t("password") }}
              </p>
              <div class="emil-input-css">
                <img src="./assets/Vector.png" alt="" class="emil-icon" />
                <form class="form-input-css-main">
                  <input
                    type="password"
                    class="emil-input-css-main"
                    v-model="password"
                    autocomplete="off"
                  />
                </form>
              </div>
            </div>

            <!--     email      -->
            <div class="emil-input">
              <p class="emil-input-title">
                {{ $t("confirmPassword") }}
              </p>
              <div class="emil-input-css">
                <img src="./assets/Vector.png" alt="" class="emil-icon" />
                <form class="form-input-css-main">
                  <input
                    type="password"
                    class="emil-input-css-main"
                    v-model="repassword"
                    autocomplete="off"
                  />
                </form>
              </div>
            </div>
          </div>
          <!-- 确定按钮 -->
          <div class="insure">
            <button class="insure-button" @click="submit1">
              {{ $t("toRegister") }}
            </button>
          </div>
          <!--          头像部分-->
          <div class="Avatar">
            <div class="Avatar-img" @click="toGetImg" v-if="!imageUrl">
              <div class="add-icon" v-if="imgUrlAv === ''">
                <i class="el-icon-plus"></i>
              </div>
              <div class="add-icon" v-if="imgUrlAv !== ''">
                <img
                  :src="
                    'https://test202257.oss-cn-shanghai.aliyuncs.com/ht…cs.com/image/369f500cab594fa382aabde52e079aec.jpg'
                  "
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  medicalUserqueryeMedicalUser,
  deadStatusUser,
  updateMedicalUser,
  addMedicalUser,
  addEducationUser,
  getUrlFromOSS
} from "../../js/api";
import AES from "../../js/AES";
import axios from "axios";
export default {
  name: "medicalStaffManagement",
  components: {},
  data() {
    return {
      imageUrl2: "",
      imgPath: "",
      imgUrlAv: "",
      password: "",
      repassword: "",
      emilData: "",
      inputData1: "", //搜索框input内容
      tableData: [],
      imageUrl: "", //头像图片地址路径
      choosename: "",
      list: [],
      stateChange: [], //更改状态
      searchData1: "", //表格第一个搜索
      searchData2: "", //表格第二个搜索
      searchData3: "", //表格第三个搜索
      searchData4: "", //表格第四个搜索
      dropdownData1: "", //第一个下拉
      currentPage: 1, //页数
      pageSize: 7, //每页条数
      loading: false, //table loading
      searchDataStart: "",
      dialogIsShow: false, //dialog弹窗标识
      dialogIsShow1: false, //dialog弹窗标识
      dialogIsShowOK: false, //dialog弹窗标识-ok
      dialogIsShowNO: false, //dialog弹窗标识-no
      dialoghandleIsShow: false, //管理员操作确定弹窗
      dialoghandleIsdelete: false, //删除确认弹窗
      stateItemName: "",
      total: 0,
      language: "",
      applyAdmin: "",
      applyAdminName: "All",
      applyAdminCode: "",
      applyAdminData: [],
      tableHeight: "", //表格高度
      userId:null
    };
  },
  created() {
    //获取当前语言的值
    this.language = window.localStorage.getItem("language");
    console.log(this.language, "语言");
    this.searchDataStart = this.$route.query.searchData;
    console.log(this.searchDataStart);
    this.getLanguage();
    this.getapplyAdmin();
    this.getList();
    this.getTableHeight();
  },
  computed: {},
  mounted() {
    window.addEventListener("setItemEvent", this.languageChange, true);
    let _this = this;
    window.onresize = () => {
      if (_this.resizeFlag) {
        clearTimeout(_this.resizeFlag);
      }
      _this.resizeFlag = setTimeout(() => {
        _this.getTableHeight();
        _this.resizeFlag = null;
      }, 100);
    };
  },
  destroyed() {
    window.removeEventListener("setItemEvent", this.languageChange, true);
  },
  methods: {
    //获取表格高度
    getTableHeight() {
      let tableH = 360; //距离页面下方的高度
      let tableHeightDetil = window.innerHeight - tableH;
      if (tableHeightDetil <= 200) {
        this.tableHeight = 200;
      } else {
        this.tableHeight = window.innerHeight - tableH;
      }
    },
    //监听语言
    languageChange(e) {
      const that = this;
      console.log("------监听数据------");
      console.log(e);
      if (e.key && e.key === "language" && e.newValue) {
        that.language = e.newValue;
        that.getapplyAdmin();
        that.FuzzyQuery();
      }
    },
    //获得语言
    getLanguage() {
      if (this.language === "CN") {
        this.applyAdmin = "userRights";
      } else {
        this.applyAdmin = "jpuserRights";
      }
    },
    //获取applyAdmin下拉
    handleCommandapplyAdmin(evt) {
      if (evt == null) {
        this.applyAdminCode = "";
        this.applyAdminName = "ALL";
      } else {
        console.log(evt);
        this.applyAdminCode = evt.code;
        this.applyAdminName = evt.name;
      }
      this.FuzzyQuery();
    },
    getapplyAdmin() {
      var that = this;
      that.getLanguage();
      axios
        .get("/api/modules-parent/common/getDateItem", {
          params: {
            dataItem: that.applyAdmin
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000" || res.data.code === "C0252") {
            console.log("--------获取数据字典接口数据applyAdmin--------");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            that.applyAdminData = aesFecInfo.data.slice(-2);
            console.log("--------获当然是看获取的状态了--------");
            console.log(that.applyAdminData);
          } else {
            console.log(res.data);
            that.$message.error(res.data.message);
          }
        })
        .catch(res => {
          console.log(res);
        });
    },
    //模糊查询
    FuzzyQuery() {
      var data = {
        emailAddress: this.searchData3,
        leadNumber: this.searchData1,
        roleName: this.applyAdminCode,
        userName: this.searchData2,
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      console.log(data);
      axios({
        method: "post",
        url: "/api/modules-parent/medicalUser/fuzzyQueryeMedicalUser",
        data: data,
        headers: {
          token: localStorage.getItem("token")
        }
      }).then(res => {
        console.log(res);
        if (res.data.code === "A0000") {
          // this.$message.error("查询成功");
          const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
          console.log(aesFecInfo);
          this.tableData = aesFecInfo.data;
          this.total = aesFecInfo.total;
        } else {
          this.$message.error(res.data.message);
        }
        console.log(res.data);
      });
    },
    //多选
    handleSelectionChange(val) {
      console.log(val);
      this.idList = [];
      for (var i = 0; i < val.length; i++) {
        this.idList.push(val[i].userId);
      }
      this.stateChange = val;
    },
    //状态下拉框
    handleCommandDrop(val) {
      this.stateCode = val;
      for (var i = 0; i < this.stateList.length; i++) {
        if (this.stateList[i].stateCode === val) {
          this.stateItemName = this.stateList[i].name;
        }
      }
    },

    //确认编辑
    submit() {
      if (this.imgUrlAv === "") {
        this.$message({
          message:
            this.language === "CN"
              ? "请选择头像"
              : "アイコンを選択してください",
          type: "warning"
        });
        return;
      }
      if (this.list.userName === "") {
        this.$message({
          message:
            this.language === "CN" ? "请填写姓名" : "氏名を記入してください",
          type: "warning"
        });
        return;
      }
      if (this.list.emailAddress === "") {
        this.$message({
          message:
            this.language === "CN"
              ? "请填写电子邮箱地址"
              : "eメールアドレスを記入してください",
          type: "warning"
        });
        return;
      }

      console.log("编辑button");
      if (this.password === this.repassword) {
        var fakeInfo = {
          avatar: this.imgPath,
          emailAddress: this.list.emailAddress,
          password: this.password,
          userId: this.list.userId,
          userName: this.list.userName
        };

        console.log(fakeInfo);
        updateMedicalUser(fakeInfo)
          .then(res => {
            console.log("----修改接口----");
            console.log(res);
            if (res.data.code === "A0000") {
              this.$message({
                message: this.language === "CN" ? "修改成功!" : "修正成功!",
                type: "warning"
              });
              this.dialogClose();
              this.getList();
              this.imgUrlAv = "";
              this.list.emailAddress = "";
              this.password = "";
              this.list.userName = "";
              this.list.userId = "";
              this.repassword = "";
            }
          })
          .catch(res => {
            console.log("----管理员用用户列表信息----");
            console.log(res);
          });
      } else {
        this.$message({
          message:
            this.language === "CN"
              ? "两次密码输入不一致!"
              : "パスワードの入力が2回一致しません!",
          type: "warning"
        });
      }
    },
    //接口 获取表格数据
    getList() {
      var fakeInfo = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize
      };
      medicalUserqueryeMedicalUser(fakeInfo)
        .then(res => {
          console.log("--------员工接口--------");
          console.log(res);
          if (res.data.code === "A0000") {
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo);
            console.log(aesFecInfo.totalPage);
            this.tableData = aesFecInfo.data;
            this.total = aesFecInfo.totalPage;
            console.log("链接成功");
          } else {
            this.$message.error("登录失败。");
          }
        })
        .catch(res => {});
    },
    //新增提交

    submit1() {
      if (this.imgPath === "") {
        this.$message({
          message:
            this.language === "CN"
              ? "请选择头像"
              : "アイコンを選択してください",
          type: "warning"
        });
        return;
      }
      if (this.list.userName === "") {
        this.$message({
          message:
            this.language === "CN" ? "请填写姓名" : "氏名を記入してください",
          type: "warning"
        });
        return;
      }
      if (this.list.emailAddress === "") {
        this.$message({
          message:
            this.language === "CN"
              ? "请填写电子邮箱地址"
              : "eメールアドレスを記入してください",
          type: "warning"
        });
        return;
      }
      if (this.password === "") {
        this.$message({
          message:
            this.language === "CN"
              ? "请填写密码"
              : "パスワードを書いてください",
          type: "warning"
        });
        return;
      }
      console.log(this.imgPath);
      if (this.password === this.repassword) {
        var fakeInfo = {
          avatar: this.imgPath,
          emailAddress: this.list.emailAddress,
          password: this.password,
          userName: this.list.userName
        };
        console.log(fakeInfo);
        console.log(fakeInfo);
        addMedicalUser(fakeInfo)
          .then(res => {
            console.log("----修改接口----");
            console.log(res);
            if (res.data.code === "A0000") {
              this.$message({
                message: this.language === "CN" ? "新增成功!" : "新規追加成功!",
                type: "warning"
              });
              this.dialogClose1();
              this.getList();
              this.imgPath = "";
              this.list.emailAddress = "";
              this.password = "";
              this.list.userName = "";
              this.repassword = "";
            }
          })
          .catch(res => {
            console.log("----管理员用用户列表信息----");
            console.log(res);
          });
      } else {
        this.$message({
          message:
            this.language === "CN"
              ? "两次密码输入不一致!"
              : "パスワードの入力が2回一致しません!",
          type: "warning"
        });
      }
    },
    //table排序
    changeTableSort(column) {
      console.log(column);
      if (column.prop === "numberCases") {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["numberCases"] - b["numberCases"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["numberCases"] - a["numberCases"]
          );
        }
      } else {
        if (column.order === "ascending") {
          this.tableData = this.tableData.sort(
            (a, b) => a["numberViewings"] - b["numberViewings"]
          );
        } else {
          this.tableData = this.tableData.sort(
            (a, b) => b["numberViewings"] - a["numberViewings"]
          );
        }
      }
    },
    //dialog关闭
    dialogClose() {
      this.dialogIsShow = false;
    },
    dialogClose1() {
      this.dialogIsShow1 = false;
    },
    //
    handleCurrentChange(val) {
      this.currentPage = val;
      this.FuzzyQuery();
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
      } else if (command === "b") {
        this.pageSize = 15;
      } else if (command === "c") {
        this.pageSize = 20;
      } else if (command === "d") {
        this.pageSize = 25;
      }
      this.currentPage = 1;
      this.FuzzyQuery();
    },
    // 编辑
    staffApplicationHandleAdd(row) {
      console.log(row);
      this.imgUrlAv = row.avatar;
      this.pdateMedicalUser = row.avatar;
      this.dialogIsShow = true;
      this.list = row;
      this.password = "";
      this.repassword = "";
      this.getUrl(row.avatar);
      // this.imgUrlAv = this.imageUrl2;
    },
    // 新增
    handleAddClick() {
      this.dialogIsShow1 = true;
      this.imgUrlAv = "";
      console.log(this.list);
    },
    //删除弹窗关闭
    dialoghandleIsdeleteClose() {
      this.dialoghandleIsdelete = false;
    },
    //删除
    managerApplicationHandleDelete(row) {
      this.dialoghandleIsdelete = true;
      console.log(row.userId);
      this.idList = [];
      this.idList.push(row.userId);
    },
    //删除
    dialoghandleIsdeleteClick() {
      var data = {
        listId: this.idList
      };
      axios({
        method: "post",
        url: "/api/modules-parent/medicalUser/deleteMedicalUser",
        data: data,
        headers: {
          token: localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.code === "A0000") {
          // this.handleAddClick();
          this.$message({
            message: "删除成功",
            type: "success"
          });
          this.getList();
        } else {
          this.$message.error(res.data.message);
        }
        console.log(res.data);
      });
    },
    //上传图片
    toGetImg() {
      let inputElement = null;
      if (inputElement === null) {
        // 生成文件上传的控件
        inputElement = document.createElement("input");
        inputElement.setAttribute("type", "file");
        inputElement.style.display = "none";

        if (window.addEventListener) {
          inputElement.addEventListener("change", this.uploadFile, false);
        } else {
          inputElement.attachEvent("onchange", this.uploadFile);
        }
        document.body.appendChild(inputElement);
      }
      inputElement.click();
    },
    //上传图片
    uploadFile(el) {
      const that = this;
      if (el && el.target && el.target.files && el.target.files.length > 0) {
        const files = el.target.files[0];
        const isLt2M = files.size / 1024 / 1024 < 1;
        const size = files.size / 1024 / 1024;
        // 判断上传文件的大小
        if (!isLt2M) {
          this.$message.error("上传头像图片大小不能超过 1MB!");
        } else if (files.type.indexOf("image") === -1) {
          //如果不是图片格式
          // this.$dialog.toast({ mes: '请选择图片文件' });
          this.$message.error("请选择图片文件");
        } else {
          const reader = new FileReader(); // 创建读取文件对象
          reader.readAsDataURL(el.target.files[0]); // 发起异步请求，读取文件
          reader.onload = function() {
            const formData = new FormData();
            formData.append("file", files); // 可以传到后台的数据
            axios
              .post("/api/modules-parent/upload/uploadPictureToOSS", formData, {
                headers: {
                  //头部参数
                  "Content-Type": "multipart/form-data",
                  token: localStorage.getItem("token")
                }
              })
              .then(function(res) {
                //请求成功
                if (res.data.code === "200 OK") {
                  console.log("-----上传图片参数-----");
                  console.log(res);
                  const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));

                  that.imgUrlAv = aesFecInfo.url;
                  that.imgPath = aesFecInfo.path;
                }
              })
              .catch(function(error) {
                //请求失败
                console.log(error);
              });
          };
        }
      }
    },
    //修改图片回显
    getUrl(url) {
      var fakeInfo = {
        message: url
      };
      getUrlFromOSS(fakeInfo)
        .then(res => {
          if (res.data.code === "200 OK") {
            console.log("图片回显接口");
            console.log(res);
            const aesFecInfo = JSON.parse(AES.decrypt(res.data.data));
            console.log(aesFecInfo, "回5+62显");
            this.imageUrl2 = aesFecInfo.message;
            this.imgUrlAv = aesFecInfo.message;
            console.log(aesFecInfo.message, "回显");
          }
        })
        .catch(() => {});
    },
    // 邮箱正则
    emailVerification() {
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
      if (reg.test(this.emilData)) {
        this.emilShow = false;
      } else {
        this.emilShow = true;
      }
    },
      // 管理员权限按钮
      handleIsShow(row) {
      console.log("给予管理员按钮");
      console.log(row);
      if (row.userStatus == 0) {
        this.dialoghandleIsShow = true;
        this.userId = row.userId;
      } else {
        this.$message({
          showClose: true,
          message: this.$t("onlyNormalUsers"),
          type: "warning"
        });
      }
    },
      //关闭管理员确定弹窗
      dialoghandleIsShowClose() {
      this.dialoghandleIsShow = false;
    },
    // 管理员权限按钮
    dialoghandleIsShowClick() {
    
      var that = this;
      axios
        .get("/api/modules-parent/medicalUser/primissionBinding", {
          params: {
            role: "admin",
            userId: that.userId
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          console.log("----测试true----");
          console.log(res);
          if (res.data.code === "A0000") {
            console.log("----退出----");
             //退出登录清除token跳转 未登录首页
             that.$router.push("/");
        localStorage.removeItem('token');
     
        this.getList();
          }
        })
        .catch(function(error) {
          this.$message.error("操作失败。");
        });
    },
    //停用按钮
    staffApplicationHandleStop(row) {
      console.log(row.userId);
      let _this = this;
      var that = row;
      const params = new URLSearchParams();
      params.append("userId", that.userId);
      axios
        .post("/api/modules-parent/medicalUser/deadStatusUser", params, {
          headers: {
            //头部参数
            "Content-Type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code === "A0000") {
            _this.$message({
              message: _this.$t("successfulOperation"),
              type: "success"
            });
            _this.getList();
          } else {
            _this.$message.error(res.data.message);
          }

          //请求成功
        })
        .catch(function(error) {
          //请求失败
          console.log(error);
        });
    },
    //模糊查询
    fuzzy() {
      console.log(this.searchData1);
    },
    //同意申请ok按钮
    passtrue(row) {
      this.userId = row.userId;
      console.log("userid=" + this.userId);
      this.dialogIsShowOK = true;
    },
    dialogOKClose() {
      this.dialogIsShowOK = false;
    },
    binDingOrganOKClick() {
      console.log("ok接口");
      var that = this;
      axios
        .get("/api/modules-parent/medicalUser/addUserBindingOrgan", {
          params: {
            userId: that.userId,
            agree: 0
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          console.log("----测试true----");
          console.log(res);
        })
        .catch(function(error) {
          console.log(error);
        });
      this.dialogIsShowOK = false;
      this.getList();
    },
    //不同意申请ok按钮
    passfalse(row) {
      this.userId = row.userId;
      console.log("userid=" + this.userId);
      this.dialogIsShowNO = true;
    },
    dialogNOClose() {
      this.dialogIsShowNO = false;
    },
    binDingOrganNOClick() {
      var that = this;
      console.log("no接口");
      axios
        .get("/api/modules-parent/medicalUser/addUserBindingOrgan", {
          params: {
            userId: this.userId,
            agree: 3
          },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
            token: localStorage.getItem("token")
          }
        })
        .then(function(res) {
          console.log("----测试true----");
          console.log(res);
        })
        .catch(function(error) {
          console.log(error);
        });
      this.dialogIsShowNO = false;
      this.getList();
    },
    //过滤器
    resetDateFilter() {
      this.$refs.filterTable.clearFilter("limits");
    },
    clearFilter() {
      this.$refs.filterTable.clearFilter();
    },
    formatter(row, column) {
      return row.address;
    },
    filterTag(value, row) {
      return row.tag === value;
    },
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    }
  }
};
</script>
<style scoped>
.main-css {
  width: 100%;
  /* height: 100%; */
}
.main-box {
  margin-top: 26px;
  width: 100%;
  height: 80%;
  padding: 0 40px 0 80px;
  box-sizing: border-box;
}
.line-button-box {
  height: 40px;
  width: 100%;
  display: flex;
  margin-top: 25px;
  /* margin-left: 40px; */
}

.button-css {
  width: 200px;
  height: 45px;
  background: #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-weight: 500;
  font-size: 18px;
  color: #fff;
  margin-right: 25px;
  text-align: center;
}
.search {
  width: 100%;
  height: 25px;
  display: flex;
}
.search /deep/ .el-input__inner {
  width: 314px;
  height: 24px;
}
.search /deep/ .el-input {
  width: 314px;
  height: 24px;
  line-height: 24px;
  box-sizing: border-box;
}
.search /deep/ .el-input__icon {
  line-height: 24px;
}
.search button {
  width: 85px;
  height: 24px;
  line-height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #51abff;
  cursor: pointer;
  margin-left: 20px;
}
.table {
  margin-top: 20px;
  width: 98%;
}
.table /deep/ .el-input__inner {
  border: 1px solid transparent;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
  padding: 0;
}
.operate {
  height: 48px;
}
.table /deep/ .el-dropdown {
  width: 100px;
}
.el-dropdown-link {
  cursor: pointer;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #00072b;
  width: 100%;
  display: inline-block;
}
.table /deep/ .el-icon-arrow-down {
  float: right;
  height: 20px;
  line-height: 20px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.table /deep/ .el-table__cell {
  position: relative;
}
.table /deep/ .is-sortable > .cell {
  display: flex;
}
.table /deep/ .caret-wrapper {
  display: inline-block;
  margin-top: -5px;
  /* position: absolute;
    top: -5px;
    right: 0;
    width: 67px; */
}
.staff-application {
  width: 94px;
  height: 24px;
  background: #fafafa;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #51abff;
  cursor: pointer;
  margin-right: 10px;
}
.manager-application {
  width: 94px;
  height: 24px;
  background: #fafafa;
  border: 1px solid #fc630c;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0.25px;
  color: #fc630c;
  cursor: pointer;
}
.pagination {
  width: 100%;
  height: 50px;
  margin-top: 10px;
}
.pagination-main {
  float: right;
  display: flex;
}
.rowsPage {
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.rowsPage-css {
  background: peru;
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}
.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  line-height: 26px;
}
.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}
.title-css {
  font-family: "lucida sans unicode", "lucida grande", sans-serif; /*字体*/
  color: #6b5656; /*字体颜色*/
  font-size: 2em; /*字体大小*/
  text-align: center; /*对齐方式*/
  line-height: 4; /*行间距*/
}
.myButton-changlimit {
  background-color: #f56c6c;
  display: inline-block;
  cursor: pointer;
  color: #ffffff;
  font-family: Arial;
  font-size: 6px;
  padding: 6px 11px;
  text-decoration: none;
}
.rowsPage-css {
  background: peru;
  width: 80px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}
.dialog-box {
  height: 630px;
  width: 400px;
  padding: 0 40px;
  padding: 20px 0;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: relative;
}
.dialog-box {
  height: 630px;
  width: 400px;
  padding: 0 40px;
  padding: 20px 0;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: relative;
}
.dialog-box-2 {
  width: 500px;
  height: 270px;
  padding: 20px 0;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  position: relative;
}

.dialog-button {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.dialog-button button {
  width: 118px;
  height: 24px;
  line-height: 24px;
  background: #ffffff;
  border: 1px solid #fc630c;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  color: #fc630c;
}
.close-button {
  width: 50px;
  text-align: center;
  line-height: 50px;
  height: 50px;
  position: absolute;
  top: 0;
  right: 0;
  font-weight: 700;
  font-size: 20px;
  color: #686868;
  cursor: pointer;
}
.dialog-img-css {
  height: 100px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-box {
  width: 66px;
  height: 66px;
  background: #fc630c;
  border-radius: 50%;
  text-align: center;
  line-height: 66px;
  font-size: 26px;
  font-weight: 500;
  color: #fff;
}
.dialog-title {
  height: 50px;
  line-height: 50px;
  text-align: center;
  width: 100%;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #686868;
}
.employee-application {
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
}
.close-button {
  width: 50px;
  text-align: center;
  line-height: 50px;
  height: 50px;
  position: absolute;
  top: 0;
  right: 0;
  font-weight: 700;
  font-size: 20px;
  color: #686868;
  cursor: pointer;
}
.bottom-box-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 324px;
  height: 56px;
}
.ja-welcome {
  width: 168px;
  height: 32px;

  /* H2 */

  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  /* identical to box height, or 133% */

  color: #212429;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;

  position: absolute;
  width: 324px;
  height: 32px;
  left: 40px;
  top: 48px;
}
.emil-input {
  padding: 0px;
  width: 324px;
  height: 66px;
  margin-right: 50px;
}
.emil-input-first {
  padding: 0px;
  width: 324px;
  height: 66px;
  margin-right: 50px;
  margin-top: 65px;
}
.emil-input-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #686868;
  margin: 8px 0px;
}

.emil-input-css {
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 24px;
  height: 40px;
  width: 320px;
  box-sizing: border-box;
}

.emil-input-css img {
  margin-top: 13px;
}
.emil-icon {
  margin-right: 10px;
  margin-left: 15px;
}

.emil-input-css-main {
  width: 240px;
  margin-right: 10px;
  height: 34px;
  line-height: 34px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #c9cfda;
}
.box-form {
  position: absolute;
  width: 324px;
  height: 64px;
  left: 40px;
  top: 124px;
}
.form-input-css-main {
  width: 240px;
  margin-right: 10px;
  height: 34px;
  float: right;
  margin-top: 2px;
}
.insure {
  height: 50px;
  margin-top: 300px;
  margin-bottom: 10px;
  margin-left: 48px;
}

.insure-button {
  background: #fc630c;
  border-radius: 24px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #ffffff;
  width: 320px;
  height: 50px;
  cursor: pointer;
}
.Avatar {
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 100px;
  right: 150px;
}
.Avatar-img {
  width: 90px;
  height: 90px;
  background: #ffffff;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  align-items: center;
  overflow: hidden;
}
.Avatar-img-icon {
  margin-top: 15px;
}
.Avatar-img-title {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #ffffff;
}
.Avatar-img .Avatar-img-main-css {
  width: 90px;
  height: 90px;
}
.add-dialog-css {
  width: 100%;
  height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.img-add-dialog-css {
  width: 80px;
  height: 80px;
  overflow: hidden;
  border-radius: 50%;
  border: 1px solid #686868;
  cursor: pointer;
}

.img-add-dialog-css img {
  width: 80px;
  height: 80px;
}

.add-icon {
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 80px;
  font-size: 34px;
  font-weight: 700;
}

.img-title {
  margin-left: -60px;
  height: 26px;
  width: 160px;
}

.add-dialog-css /deep/ .el-form {
  width: 250px;
}

.add-dialog-css /deep/ .el-form-item {
  margin-bottom: 5px;
}
.table /deep/ .el-dropdown {
  width: 120px !important;
}
.add-icon /deep/ img {
  width: 90px;
  height: 90px;
}
</style>



// WEBPACK FOOTER //
// src/pages/medicalStaffManagement/index.vue